<div class="color-picker">
  <button class="color-picker-button"
          [ngStyle]="{ 'background-color' : value }">
    <input type="color"
           class="color-input"
           (click)="onClick($event)"
           [value]="value"
           (change)="onChange($event)">
  </button>
</div>